/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ supportPlanId: ZodTypes.Id });

export const SupportPlanDelete = {
  id: 'support-plan.delete',
  tag: 'Common',
  summary: 'Support Plan Delete',
  description: 'Delete a support plan',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/support-plans/${params.supportPlanId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
